import { useLocation } from 'react-router-dom';
import AdminLayout from '../admin/layout/AdminLayout';
import OperatorLayout from '../operator/layout/OperatorLayout';
import CollectorLayout from '../collector/layout/CollectorLayout';
import GameMasteerLayout from '../gameMaster/layout/GameMasteerLayout';
import PlayerLayout from '../player/layout/PlayerLayout';

type LayoutTypes = {
  children: JSX.Element;
};

const Layout = ({ children }: LayoutTypes): JSX.Element => {
  const location = useLocation();

  if (location.pathname !== '/notfound') {
    if (location.pathname.startsWith('/admin/')) {
      return <AdminLayout location={location} children={children} />;
    }
    if (location.pathname.startsWith('/operator/')) {
      return <OperatorLayout location={location} children={children} />;
    }
    if (location.pathname.startsWith('/collector/')) {
      return <CollectorLayout location={location} children={children} />;
    }
    if (location.pathname.startsWith('/assist/')) {
      return <GameMasteerLayout location={location} children={children} />;
    }
    if (location.pathname.startsWith('/user/')) {
      return <PlayerLayout location={location} children={children} />;
    }
  }

  return children;
};

export default Layout;
